import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ExternalLink } from "lucide-react";

let cache = null;
export function usePartners() {
  const [p, setP] = useState(cache || {});
  useEffect(() => { if (cache) return; api.get("/public/partners").then((r) => { cache = r.data; setP(r.data); }).catch(() => {}); }, []);
  return p;
}

export default function PartnerLink({ slot, label, className = "" }) {
  const partners = usePartners();
  const p = partners[slot];
  if (!p) return null;
  return (
    <a data-testid={`partner-${slot}`} href={p.url} target="_blank" rel="noreferrer sponsored" onClick={() => api.post(`/public/partners/${slot}/click`).catch(() => {})}
       className={`inline-flex items-center gap-1.5 text-xs px-3 min-h-[32px] rounded-lg border border-border bg-white hover:bg-secondary font-medium ${className}`}>
      {label}{p.name ? ` with ${p.name}` : ""} <ExternalLink size={12} />
    </a>
  );
}
